const baseUrl = window.location.origin || window.location.protocol + '//' + window.location.host;

const environment = {
    baseUrl,
    apiBase: `${baseUrl}/api/v3`,
};

const env = { ...(window.__env || {}), ...environment };
export default env;
